
































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CostPart, WorkordersApi, PerformoSettings } from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    settings: 'settings',
    api: 'ordersApi'
  })
})
export default class UpdateCostPart extends Vue {
  private api!: WorkordersApi;
  private settings!: PerformoSettings;

  @Prop({ required: true })
  private part!: CostPart;
  @Prop({ required: false })
  private disabled!: boolean;

  private updatePartPopoverTippy = false;
  private isLoading = false;

  // these values are displayed on render and will throw an error if undefined
  private quantity = this.part.partQuantity ? this.part.partQuantity : null;
  private quantityWanted = this.part.partQuantityWanted
    ? this.part.partQuantityWanted
    : null;

  private get disableSave() {
    if (this.settings.advancedPartsFunctionalityFlag) {
      if (
        this.quantityWanted == null ||
        this.quantityWanted.toString() == '' ||
        // Only numbers allowed
        !/^\d+$/.test(this.quantityWanted.toString()) ||
        this.quantityWanted <= 0
      )
        return true;
    }
    if (this.quantity) {
      if (this.quantity <= 0 || !/^\d+$/.test(this.quantity.toString()))
        return true;
    }
    if (
      this.quantity == this.part.partQuantity &&
      this.quantityWanted == this.part.partQuantityWanted
    )
      return true;
    else return false;
  }
  openPopover() {
    this.quantity = this.part.partQuantity ? this.part.partQuantity : null;
    this.quantityWanted = this.part.partQuantityWanted
      ? this.part.partQuantityWanted
      : null;
    this.updatePartPopoverTippy = true;
  }

  async savePart() {
    if (this.part.workorderId && this.part.costId) {
      this.isLoading = true;
      try {
        const updatedPart = await this.api.updateWorkOrderCostPartQuantity({
          workorderId: this.part.workorderId,
          costId: this.part.costId,
          // action will not accept a null value so we convert null values to undefined
          quantity: this.quantity ? this.quantity : undefined,
          quantityWanted: this.quantityWanted ? this.quantityWanted : undefined
        });
        this.updatePartPopoverTippy = false;
        this.isLoading = false;
        this.$emit('part-updated', updatedPart);
      } catch (error) {
        this.$emit('error', error);
      }
    }
  }
}
